export const mainProgramData = {
  title: "Program",
  agendaItems: [
    {
      subtitle: "Pátek 14.11.2025",
      descriptions: [
        "Příjezd účastníků a registrace",
        "Individuální program",
        "Slavnostní zahájení srazu",
        "Koncert skupiny Forfolk"
      ],
      src: "/images/program/ilustracni-foto-autobusovy-zajezd.JPG"
    },
    {
      subtitle: "Sobota 15.11.2025",
      descriptions: [
        "Autobusové zájezdy",
        "Svařák fest - soutěž o nejlepší svařené víno",
        "Beseda o historii regionu Hlučínska",
        "Folklorní večer"
      ],
      src: "/images/program/turisticky-pochod.JPG"
    },
    {
      subtitle: "Neděle 16.11.2025 - hlavní srazový den",
      descriptions: [
        "Turistické pochody",
        "Farmářské trhy",
        "Společenský večer",
        "Seniorská káva"
      ],
      src: "/images/program/predavani-stafety.jpg"
    },
    {
      subtitle: "Pondělí 17.11.2025",
      descriptions: [
        "Individuální program",
        "Komentované prohlídky Hlučína",
        "Odjezd účastníků",
      ],
    },
  ]
};